export function FakeGroupCell() {
  return <th />;
}
